export default "__VITE_ASSET__CR4OC6d9__"